import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { MapPinIcon, PhoneIcon } from 'lucide-react';
import { business } from '../data/business';
import { PapelPicado } from './PapelPicado';
const ease = [0.23, 1, 0.32, 1] as const;
export function TruckHero() {
  const reduce = useReducedMotion();
  return <section id="top" aria-label="Vegas Taco Truck food truck" className="w-full bg-cream" data-id="element-120" data-mp="m4iyg6ohsk4w">
      <PapelPicado className="pt-2" count={24} data-id="element-121" data-mp="7fmw8q94a1c7" />
      <div className="mx-auto max-w-6xl px-4 pt-3 sm:px-6" data-id="element-122" data-mp="7ev09ebly1le">
        <motion.div initial={reduce ? false : {
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} className="relative overflow-hidden rounded-3xl bg-ink ring-4 ring-verde" data-id="element-123" data-mp="c868njw2iqff">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/73f9700b-e80f-4cc4-b2a0-293ea0757d52.jpg" alt="The green, white and red Vegas Taco Truck with papel picado banners over its serving window" className="aspect-[4/3] w-full object-cover sm:aspect-[16/9] lg:aspect-[21/9]" data-id="element-124" data-mp="3knhie86425ab" />
        </motion.div>

        <div className="flex flex-col gap-6 py-8 md:flex-row md:items-end md:justify-between md:py-10" data-id="element-125" data-mp="1nh6yxsyq6rhx">
          <div className="max-w-2xl" data-id="element-126" data-mp="21crdydbc2pk2">
            <p className="font-display text-xl text-verde sm:text-2xl" data-id="element-127" data-mp="1wf932hdra09f">¡Bienvenidos a</p>
            <h1 className="font-display text-5xl leading-[0.95] text-salsa sm:text-6xl lg:text-7xl" data-id="element-128" data-mp="18pwwlp9tc6at">
              Vegas Taco Truck!
            </h1>
            <p className="mt-3 text-lg text-muted sm:text-xl" data-id="element-129" data-mp="14qfsp0a1bh7r">{business.tagline}</p>
          </div>

          <div className="flex flex-col gap-3 md:items-end" data-id="element-130" data-mp="1ihatdpadqs09">
            <p className="inline-flex items-center gap-2 text-sm font-medium text-ink" data-id="element-131" data-mp="1dp15sfwqm415">
              <span className="relative flex h-2.5 w-2.5" aria-hidden="true" data-id="element-132" data-mp="pz6u41o5mlih">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-verde opacity-60 motion-reduce:animate-none" data-id="element-133" data-mp="l0lspyx61vsg" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-verde" data-id="element-134" data-mp="2l1tqhercn5s3" />
              </span>
              <span className="font-semibold text-verde" data-id="element-135" data-mp="2q0dgbq92d1pq">Abierto hoy · Open today</span>
              <span className="text-muted" data-id="element-136" data-mp="2utzjmrtc7t8v">· {business.todayHours}</span>
            </p>
            <p className="inline-flex items-center gap-2 text-sm text-muted" data-id="element-137" data-mp="2zs15fki5e6o1">
              <MapPinIcon className="h-4 w-4 text-salsa" aria-hidden="true" data-id="element-138" data-mp="22495wjvmatda" />
              {business.todayStop}
            </p>
            <div className="mt-1 flex flex-wrap gap-3" data-id="element-139" data-mp="2745b2mg1wquf">
              <a href={business.phoneHref} className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-salsa px-6 py-3 font-bold text-white hover:bg-salsa-dark transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-salsa focus-visible:ring-offset-2 focus-visible:ring-offset-cream" data-id="element-140" data-mp="2c26r0yi6ka1o">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-141" data-mp="3rl0btf4kkmks" />
                {business.phoneDisplay}
              </a>
              <a href="#menu" className="inline-flex items-center whitespace-nowrap rounded-full border-2 border-verde px-6 py-3 font-bold text-verde hover:bg-verde hover:text-white transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-verde focus-visible:ring-offset-2 focus-visible:ring-offset-cream" data-id="element-142" data-mp="1bu8phvqljgd0">
                Ver el menú
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}